class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.setupEventListeners();

    this.input = document.getElementById('Search-In-Template');
    this.resetBtn = this.input?.closest('form')?.querySelector('button[type="reset"]');
    this.persistentContainer = document.getElementById('main-persistent-initial');

    this.initPersistentMode();
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener("focus", this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) =>
      form.addEventListener("reset", this.onFormReset.bind(this)),
    );
    this.allSearchInputs.forEach((input) =>
      input.addEventListener("input", this.onInput.bind(this)),
    );
  }

  onFormReset(event) {
    // Only sync other inputs if the reset came from this component's own form
    if (event.target !== this.input.form) return;
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync("", this.input);
    }
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: "smooth" });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  initPersistentMode() {
    if (!this.resetBtn || !this.persistentContainer) return;

    // Activate persistent mode ONLY when reset is clicked here
    this.resetBtn.addEventListener('click', () => {
      setTimeout(() => {
        if (!this.input.value.trim()) {
          document.body.classList.add('main-search-persistent-mode');
          this.persistentContainer.classList.remove('hidden');
          document.body.classList.remove("gl-search-open");
          this.renderRecentInPersistent();
        }
      }, 30);
    });

    // When typing → keep background visible, let predictive overlay
    this.input.addEventListener('input', () => {
      // No need to hide anything – persistent mode already handles visibility
    });

    // When actually submitting form → exit persistent mode
    this.input.closest('form').addEventListener('submit', () => {
      document.body.classList.remove('main-search-persistent-mode');
      this.persistentContainer.classList.add('hidden');
    });
  }

  renderRecentInPersistent() {
    const list = this.persistentContainer.querySelector('.recent-searches-list');
    if (!list) return;

    const searches = JSON.parse(localStorage.getItem('recent-searches-main') || '[]');
    const module = list.closest('.recent-searches-module');

    if (searches.length === 0) {
      module.style.display = 'none';
      return;
    }

    module.style.display = 'block';
    list.innerHTML = '';

    searches.forEach(term => {
      const a = document.createElement('a');
      a.href = `/search?q=${encodeURIComponent(term)}&options[prefix]=last`;
      a.className = 'px-5 py-2.5 bg-gray-100 hover:bg-gray-200 rounded-full text-sm';
      a.textContent = term;
      list.appendChild(a);
    });
  }
}

customElements.define("main-search", MainSearch);

// Global Clear All listener for main-search (syncs with header)
document.addEventListener('click', e => {
  if (e.target.matches('#main-persistent-initial .clear-recent-searches')) {
    const storageKey = 'recent-searches-main';
    localStorage.removeItem(storageKey);
    if (typeof window.renderRecentSearches === 'function') {
      window.renderRecentSearches(); // Updates BOTH main and header instantly
    }
  }
});

// Save recent search on main-search submit (syncs with header)
document.addEventListener('submit', e => {
  if (e.target.matches('main-search form')) {
    const input = e.target.querySelector('input[name="q"]');
    if (input && input.value.trim()) {
      const storageKey = 'recent-searches-main';
      let searches = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (!searches.includes(input.value.trim())) {
        searches.unshift(input.value.trim());
        if (searches.length > 10) searches = searches.slice(0, 10);
        localStorage.setItem(storageKey, JSON.stringify(searches));
        window.renderRecentSearches(); 
      }
    }
  }
});

// Preserve vendor parameter in URL for Globo Filter
(function () {
  function preserveVendorParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const vendor = urlParams.get("vendor");

    if (vendor) {
      // Store vendor in sessionStorage for persistence
      sessionStorage.setItem("searchVendor", vendor);

      // Monitor URL changes and ensure vendor parameter is preserved
      let lastUrl = window.location.href;
      const checkUrl = setInterval(() => {
        if (window.location.href !== lastUrl) {
          lastUrl = window.location.href;
          const currentParams = new URLSearchParams(window.location.search);
          if (
            !currentParams.get("vendor") &&
            sessionStorage.getItem("searchVendor")
          ) {
            currentParams.set("vendor", sessionStorage.getItem("searchVendor"));
            const newUrl =
              window.location.pathname + "?" + currentParams.toString();
            window.history.replaceState({}, "", newUrl);
          }
        }
      }, 100);

      // Clean up on page unload
      window.addEventListener("beforeunload", () => {
        clearInterval(checkUrl);
      });
    } else if (sessionStorage.getItem("searchVendor")) {
      // Restore vendor if it exists in sessionStorage
      const currentParams = new URLSearchParams(window.location.search);
      currentParams.set("vendor", sessionStorage.getItem("searchVendor"));
      const newUrl = window.location.pathname + "?" + currentParams.toString();
      window.history.replaceState({}, "", newUrl);
    }
  }

  // Run on page load
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", preserveVendorParameter);
  } else {
    preserveVendorParameter();
  }

  // Run after Globo Filter renders
  window.addEventListener("globoFilterRenderCompleted", function (event) {
    preserveVendorParameter();
    moveClearAllButton();
    setTimeout(function () {
      cardWishlist();
      swatchImageChange();
    }, 2000);
  });
})();

function moveClearAllButton() {
  // Only run on search page
  const isSearch =
    window.location.pathname.includes("/search") ||
    document.querySelector(".template-search");
  if (!isSearch) return;

  // Try scoped selector first, fall back to any .globo-selected-items on the page
  const container =
    document.querySelector("#gf-grid .globo-selected-items") ||
    document.querySelector(".globo-selected-items");

  if (!container) return;

  // Count real filter pills (exclude any previously injected Clear All wrapper)
  const hasItems =
    container.querySelectorAll(".selected-item:not(.search-clear-btn-wrapper)")
      .length > 0;

  // Remove any previously injected button to avoid duplicates
  const existing = container.querySelector(".search-clear-btn-wrapper");
  if (existing) existing.remove();

  if (hasItems) {
    // Create the Clear All button fresh each time
    const li = document.createElement("li");
    li.className = "selected-item gf-option-label search-clear-btn-wrapper";

    const btn = document.createElement("button");
    btn.className = "link-button clear-link-button mobile-clear-btn";
    btn.setAttribute("onclick", "handleClearAll(event)");
    btn.setAttribute("data-theme", "default");
    btn.setAttribute("type", "button");
    btn.style.textDecoration = "underline";
    btn.textContent = "Clear All";

    li.appendChild(btn);
    container.appendChild(li);

    // Ensure the container itself is visible
    container.style.removeProperty("display");
  }
}

function cardWishlist() {
  let wishlist = JSON.parse(localStorage.getItem("myWishlist")) || [];
  // Initialize all wishlist buttons in grid
  document
    .querySelectorAll(".wishlist-collection-icon")
    .forEach((wishlistBtn) => {
      const productId = wishlistBtn.dataset.productId;
      const variantId = wishlistBtn.dataset.variantId;
      // Find matching remove button (sibling or via data attribute)
      const addedBtn = wishlistBtn
        ?.closest(".card-wishlist-share-wrapper")
        ?.querySelector(".remove-list");
      if (!wishlistBtn || !addedBtn) return;

      // ✅ Detect current color code (if swatches exist in this card)
      let colorcode = "";
      const cardContainer =
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="Color"]') ||
        wishlistBtn
          .closest(".product-card-wrapper")
          ?.querySelector('[data-option-name="color"]');
      const selectedColor = cardContainer?.querySelector(
        ".spf-product__swatch.is-selected",
      )?.dataset?.optionValue;
      if (selectedColor) {
        colorcode = selectedColor;
      }

      // Show correct button on load
      if (wishlist.some((item) => item.variantColor === colorcode)) {
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
      } else {
        wishlistBtn.classList.remove("!hidden");
        addedBtn.classList.add("!hidden");
      }

      // Add to wishlist
      wishlistBtn.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let colorcode = "";
        const cardContainer =
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="Color"]') ||
          e.target
            .closest(".product-card-wrapper")
            ?.querySelector('[data-option-name="color"]');
        const selectedColor = cardContainer.querySelector(
          ".spf-product__swatch.is-selected",
        )?.dataset?.optionValue;
        if (selectedColor) {
          colorcode = selectedColor;
        }

        const product = {
          id: productId,
          variantId: variantId,
          title: wishlistBtn.dataset.productTitle,
          handle: wishlistBtn.dataset.productHandle,
          variantColor: colorcode,
          addedAt: Date.now(),
        };

        wishlist.push(product);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        wishlistBtn.classList.add("!hidden");
        addedBtn.classList.remove("!hidden");
        // If flyout already exists, remove it first
        const existingFlyout = document.querySelector(
          '[data-testid="my-list-flyout"]',
        );
        if (existingFlyout) existingFlyout.remove();

        // Create flyout HTML
        let flyoutClasses = "";

        let smallMessageHTML = "";
        if (!window.wishlistLabel?.customerLoggedIn) {
          smallMessageHTML = `
        <div>
         <p class="catalog-MyListNotifications-module__bigMessage" data-property="GLB_GUEST_ITEM_SAVED">
                <span class="catalog-MyListNotifications-module__heart">
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-hco"></span>
                </span>
                <span class="adding_text">${window.wishlistLabel.addToWishlist}</span>
              </p>
          <div class="catalog-MyListNotifications-module__smallMessage">
            <p>
              <span data-property="GLB_SIGNIN_HEARTS">
<modal-opener data-modal="#LoginModal">
        <button class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
          <span class="underline">${window.wishlistLabel.signIn}</span>
        </button>
      </modal-opener>${window.wishlistLabel.listSubtext}              </span>
            </p>
            <p>
              <span data-property="GLB_CREATEACCOUNTLINK">

        <button id="createAccountModal" class="login-trigger signIn" data-variant="tertiary-light" data-redirect="/account">
          <span class="underline">${window.wishlistLabel.createAcc}</span>
        </button>
                </span>
            </p>
          </div>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime catalog-MyListNotifications-module__loggedOut";
        } else {
          smallMessageHTML = `
          <div>
            <p class="catalog-MyListNotifications-module__bigMessage">
            <span class="catalog-MyListNotifications-module__heart">
                  
                  <span aria-hidden="true" class="icon" data-icon="heart-filled-hco"></span>

                </span>${window.wishlistLabel.itemSaveLogin}</p>
          </div>
        `;
          flyoutClasses =
            "catalog-MyListNotifications-module__flyout catalog-MyListNotifications-module__firstTime";
        }

        // Create flyout HTML with conditional content
        const flyoutHTML = `
        <div data-testid="my-list-flyout" class="flyout-top-gap">
          <div class="${flyoutClasses}">  
          <div>
              ${smallMessageHTML}
              <p class="catalog-MyListNotifications-module__myListButton block">
                <a class="button submit-btn wishlist-flybtn" data-full-width="true" data-theme="inverse" href="/pages/my-list">${window.wishlistLabel.viewList}</a>
              </p>
            </div>
          </div>
        </div>
      `;
        // // Insert into header
        // const header = document.querySelector(".header-wrapper");
        // if (header) {
        //   header.insertAdjacentHTML("beforeend", flyoutHTML);
        // }

        // // Auto-hide after 3 seconds
        // setTimeout(() => {
        //   const flyout = document.querySelector(
        //     '[data-testid="my-list-flyout"]'
        //   );
        //   if (flyout) flyout.remove();
        // }, 3000);

        const isAppView = window.location.search.includes("app-view=true");

        if (isAppView) {
          // Bottom fixed layout for app-view mode
          const appViewFlyout = `
            <div class="app-view-wishlist-flyout">
              <p class="flyout-text">The item has been saved</p>
              <a href="/pages/my-list" class="flyout-btn">My List</a>
            </div>
          `;

          //   const appViewFlyout = `
          //   <div class="app-view-wishlist-flyout">
          //     <p class="flyout-text">The item has been saved</p>
          //   </div>
          // `;
          document.body.insertAdjacentHTML("beforeend", appViewFlyout);

          //Auto-hide after 3 seconds
          setTimeout(() => {
            const flyout = document.querySelector(".app-view-wishlist-flyout");
            if (flyout) flyout.remove();
          }, 3000);
        } else {
          // Default header flyout (desktop/normal collection)
          const header = document.querySelector(".header-wrapper");
          if (header) {
            header.insertAdjacentHTML("beforeend", flyoutHTML);
            toggleFlyoutGap();
          }

          setTimeout(() => {
            const flyout = document.querySelector(
              '[data-testid="my-list-flyout"]',
            );
            if (flyout) flyout.remove();
          }, 3000);
        }
      });

      // Remove from wishlist
      addedBtn.addEventListener("click", function () {
        wishlist = wishlist.filter((item) => item.variantColor !== colorcode);
        localStorage.setItem("myWishlist", JSON.stringify(wishlist));
        syncWishlist();
        addedBtn.classList.add("!hidden");
        wishlistBtn.classList.remove("!hidden");
      });
    });
}

function swatchImageChange() {
  document.querySelectorAll(".spf-card-swatch").forEach((swatch) => {
    // Hover to change image
    swatch.addEventListener("mouseenter", (e) => {
      console.log(e);
      e.preventDefault();
      const mediaSrc = e.currentTarget.dataset.mediaSrc;
      const card = e.currentTarget.closest(".card-wrapper");
      if (!card || !mediaSrc) return;

      const mediaContainer = card.querySelector(".card__media .media");
      if (!mediaContainer) return;

      // Remove any previously injected swatch preview image
      const existing = mediaContainer.querySelector(".swatch-preview");
      if (existing) existing.remove();

      // Create a new image
      const newImg = document.createElement("img");
      newImg.src = mediaSrc;
      newImg.className = "swatch-preview";
      newImg.setAttribute("style", "opacity: 1; z-index: 1;");
      newImg.setAttribute("alt", ""); // optional
      newImg.setAttribute("loading", "lazy");
      // Insert before all children (as the first child)
      mediaContainer.insertBefore(newImg, mediaContainer.firstChild);
    });

 
    swatch.addEventListener("mouseleave", (e) => {
      const card = e.currentTarget.closest(".card-wrapper");
      if (!card) return;
      const mediaContainer = card.querySelector(".card__media .media");
      const existing = mediaContainer?.querySelector(".swatch-preview");
      if (existing) existing.remove();
    });
  });
}


